export const isBamfExam = (exam) => [1010, 1013, 1014, 1015, 1016].includes(exam?.examSubject?.id);
export const isDtbExam = (exam) => [1013, 1014, 1015, 1016].includes(exam?.examSubject?.id);
export const isDigitalSubject = (id) => !!id && id >= 8000 && id < 9000;
export const isDigitalExam = (exam) => isDigitalSubject(exam?.examSubject?.id);

export const getDeliveryAddressType = (exam) =>
  isDtbExam(exam) ? 'BAMF_LICENSED_LOCATION' : 'SHIP_TO';
